module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-header"
  }, [_c('ul', {
    staticClass: "nav-links clearfix"
  }, [_c('li', {
    class: {
      active: !_vm.previewMarkdown
    }
  }, [_c('a', {
    attrs: {
      "href": "#md-write-holder",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleMarkdownPreview($event)
      }
    }
  }, [_vm._v("\n        Write\n      ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.previewMarkdown
    }
  }, [_c('a', {
    attrs: {
      "href": "#md-preview-holder",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleMarkdownPreview($event)
      }
    }
  }, [_vm._v("\n        Preview\n      ")])]), _vm._v(" "), _c('li', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "toolbar-group"
  }, [_c('toolbar-button', {
    attrs: {
      "tag": "**",
      "button-title": "Add bold text",
      "icon": "bold"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "*",
      "button-title": "Add italic text",
      "icon": "italic"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "> ",
      "prepend": true,
      "button-title": "Insert a quote",
      "icon": "quote-right"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "`",
      "tag-block": "```",
      "button-title": "Insert code",
      "icon": "code"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "* ",
      "prepend": true,
      "button-title": "Add a bullet list",
      "icon": "list-ul"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "1. ",
      "prepend": true,
      "button-title": "Add a numbered list",
      "icon": "list-ol"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "* [ ] ",
      "prepend": true,
      "button-title": "Add a task list",
      "icon": "check-square-o"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar-group"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "toolbar-btn js-zen-enter",
    attrs: {
      "aria-label": "Go full screen",
      "data-container": "body",
      "tabindex": "-1",
      "title": "Go full screen",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88540444"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/header.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-88540444"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/header.vue
// module chunks = common_vue